import type { TreeGraphInstance } from "$/lib/types/Graphs.types";
import React, { useRef, useState } from "react";
import { ResponsiveContainer, Treemap } from "recharts";
import TreeGraphContent from "./TreeGraphContent";

type Props = {
  data: TreeGraphInstance[];
};

const TreeGraph = ({ data }: Props) => {
  const [ref, setRef] = useState<React.RefObject<HTMLDivElement>>(
    useRef<HTMLDivElement>(null),
  );

  return (
    <div className="w-full grow overflow-hidden rounded-2xl">
      <ResponsiveContainer
        // @ts-expect-error - `ref` prop has incorrect type in `ResponsiveContainer`
        ref={setRef}
        width="100%"
        height="100%"
        minHeight={data.length * 58}
        // minWidth={300}
      >
        <Treemap
          width={200}
          height={200}
          data={data}
          content={<TreeGraphContent parentWidth={ref.current?.clientWidth} />}
          animationDuration={0}
          dataKey="size"
          aspectRatio={1 / 1}
          className="[&_path]:!stroke-none"
          stroke="#fff"
        />
      </ResponsiveContainer>
    </div>
  );
};

export default TreeGraph;
